
export var inputValidations = {
    hsn : (data) => {
        if(data === "" || data === undefined || data === null || !data){
            return {"status": false, "msg": "HSN code cannot be empty."};
        }
        // Remove any whitespace
        const hsnValue = data.trim();
        
        // Check if empty
        if (!hsnValue || hsnValue.length === 0) {
            return {"status": false, "msg": "HSN code cannot be empty."};
        }
        
        // Check if contains alphabetic characters (reject)
        if (/[a-zA-Z]/.test(hsnValue)) {
            return {"status": false, "msg": "HSN code cannot contain alphabetic characters."};
        }
        
        // Check if contains alphanumeric characters (reject)
        if (/[a-zA-Z0-9]/.test(hsnValue) && /[a-zA-Z]/.test(hsnValue)) {
            return {"status": false, "msg": "HSN code cannot contain alphabetic characters."};
        }
        
        // Check if less than 4 digits (reject)
        if (hsnValue.length < 4) {
            return {"status": false, "msg": "HSN code must be at least 4 digits long."};
        }
        
        // Check if more than 8 digits (reject)
        if (hsnValue.length > 8) {
            return {"status": false, "msg": "HSN code cannot be more than 8 digits long."};
        }
        
        // Check if contains only numeric characters
        if (!/^\d+$/.test(hsnValue)) {
            return {"status": false, "msg": "HSN code must contain only numeric characters."};
        }
        
        // All validations passed
        return {"status": true, "msg": "Valid HSN code."};
    }
}